<div
  class="course-card bg-white rounded-lg overflow-hidden border border-gray-200 shadow-md h-full flex flex-col"
>
  <div class="course-image-container relative">
    <div class="course-badge-container absolute top-2 right-2 z-10 flex flex-row-reverse gap-2">
      <!-- <ng-container *ngIf="live?.is_test_published">
        <span class="badge bg-blue-500 text-white px-2 py-1 rounded text-xs font-bold uppercase">
          Test Published
        </span>
      </ng-container> -->
    </div>
    <a [routerLink]="['/live', live?.uuid]">
      <div class="aspect-w-16 aspect-h-9">
        <img
          [src]="live?.thumb_path || 'assets/images/no-image.jpg'"
          [alt]="live?.title"
          class="w-full h-full object-cover border-b border-gray-200"
          loading="lazy"
        />
      </div>
    </a>
  </div>

  <div class="course-detail-container p-4 flex-grow">
    <div class="course-detail-item title mb-3">
      <h3 class="text-lg font-semibold leading-tight">
        <a [routerLink]="['/live', live?.uuid]" class="text-gray-800 hover:text-primary-600">
          {{ live?.title }}
        </a>
      </h3>
    </div>

    <div class="space-y-2">
      <div class="text-sm text-gray-600 flex items-start">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
          />
        </svg>

        <span> <span class="font-medium">Code:</span> {{ live?.code }} </span>
      </div>

      <div class="text-sm text-gray-600 flex items-start">
        <svg
          class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <span>
          <span class="font-medium">Release at:</span>
          {{ formatDate(live?.release_date) }}
        </span>
      </div>

      <div class="text-sm text-gray-600 flex items-start">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
          />
        </svg>

        <span>
          <span class="font-medium">Location:</span>
          {{ live?.location || 'N/A' }}
        </span>
      </div>
    </div>
  </div>

  <div class="course-footer-container p-2 bg-gray-50 border-t" *ngIf="shouldShowButton()">
    <div class="course-detail-item access-button flex space-x-1">
      <ng-container *ngIf="(live?.participations?.length ?? 0) > 0">
        <button
          *ngIf="
            live?.participations?.[0]?.progress !== 100 &&
            live?.participations?.[0]?.progress !== null
          "
          (click)="startLive(live?.uuid ?? '')"
          class="font-semibold btn bg-green-500 hover:bg-green-600 text-white px-1 py-2 rounded transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
        >
          Continue Activity
        </button>

        <a
          *ngIf="live?.participations?.[0]?.progress === 100"
          [routerLink]="'/my-account/certificates'"
          class="font-semibold btn bg-green-500 hover:bg-green-600 text-white px-1 py-2 rounded transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px] flex justify-center items-center"
          ><svg
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="h-4 w-4 mr-1"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
            />
          </svg>
          Certificate</a
        >

        <a
          [routerLink]="['/live', live?.uuid]"
          class="font-semibold btn bg-primary-500 hover:bg-primary-600 text-white px-1 py-2 rounded transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
        >
          Activity Details
        </a>
      </ng-container>
      <a
        *ngIf="(live?.participations?.length ?? 0) === 0"
        [routerLink]="['/live', live?.uuid]"
        class="font-semibold btn text-white px-1 py-2 rounded bg-primary-500 hover:bg-primary-600 transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
      >
        Activity Details
      </a>
    </div>
  </div>
</div>
